









import { State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
  },
})
export default class PageRoles extends Vue {
  @Getter('role/all') roles!: Role[];

  i18n: string = 'views.roles.index';

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 80px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Product) => `#${model.id}`,
        width: 75,
      },
    ],
  };
}
